import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthentication, useCurrentUser, usePermission } from '../hooks';
import { ProgressIndicator } from '../components';
import {
  UserPermission,
  UserRoleCategory,
  UserRoleCategoryPath,
} from '../enums';

const Home: React.FC = () => {
  const { userRoleCategory } = useAuthentication();
  const user = useCurrentUser();
  const { hasPermission, hasOneOfPermissions, loading } = usePermission();
  const navigate = useNavigate();

  useEffect(() => {
    if (userRoleCategory && user && !loading) {
      if (userRoleCategory !== UserRoleCategory.Customer) {
        navigate(`${UserRoleCategoryPath[userRoleCategory]}/dashboard`);
      } else {
        redirectCustomer();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate, loading, user]);

  const redirectCustomer = () => {
    if (
      hasPermission(UserPermission.ViewInventory) &&
      (user?.canSeeCSA || user?.canSeeUL)
    ) {
      navigate('/inventory');
    } else if (
      hasOneOfPermissions([
        UserPermission.ManageCompanyReservations,
        UserPermission.ManageOwnReservations,
      ])
    ) {
      navigate('/reservations');
    } else if (hasPermission(UserPermission.ViewCompanyUsers)) {
      navigate('/users');
    } else {
      navigate('/settings');
    }
  };

  return <ProgressIndicator />;
};

export default Home;
